import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["disabled", "invalid", "format", "rangeStart", "rangeEnd", "showStart", "tooltip"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @file Slider 滑竿内容
 * @author Yu Zong(liuxuanzy@qq.com)
 */
import { useRegionClick, useRegionSize } from '@tencent/glue-react-region';
import React, { memo, useCallback } from 'react';
import { useCombineRef, useRefGetter } from '@tencent/glue-react-use';
import { ViewSliderContent } from '../../views/ViewSliderContent';
import { Popper } from '../Popper';
import { SliderDragger } from './SliderDragger';
export var SliderContent = memo(function (props) {
  var disabled = props.disabled,
      _props$invalid = props.invalid,
      invalid = _props$invalid === void 0 ? false : _props$invalid,
      format = props.format,
      rangeStart = props.rangeStart,
      rangeEnd = props.rangeEnd,
      showStart = props.showStart,
      tooltip = props.tooltip,
      extra = _objectWithoutProperties(props, _excluded);

  var _useRegionClick = useRegionClick(),
      _useRegionClick2 = _slicedToArray(_useRegionClick, 2),
      regionRef = _useRegionClick2[0],
      regionClick = _useRegionClick2[1];

  var disableGetter = useRefGetter(disabled);
  var onClick = useCallback(function (e) {
    if (disableGetter()) {
      return;
    }

    regionClick(e);
  }, []);

  var _useRegionSize = useRegionSize(),
      _useRegionSize2 = _slicedToArray(_useRegionSize, 1),
      containerRef = _useRegionSize2[0];

  var ref = useCombineRef(regionRef, containerRef);
  return React.createElement(Popper, null, React.createElement(ViewSliderContent, _objectSpread(_objectSpread({}, extra), {}, {
    elRef: ref,
    onSliderClick: onClick,
    rangeStart: rangeStart,
    rangeEnd: rangeEnd
  }), showStart && React.createElement(SliderDragger, {
    draggable: !disabled,
    name: "start",
    format: format,
    invalid: invalid,
    tooltip: tooltip
  }), React.createElement(SliderDragger, {
    draggable: !disabled,
    name: "end",
    format: format,
    invalid: invalid,
    tooltip: tooltip
  })));
});